import { TitleSkeleton } from './Title';
import { TTableSkeletonProps } from './types';

export const TableSkeleton = ({
  rows = 3,
  showTitle = true,
  rowHeight = 40,
}: TTableSkeletonProps) => {
  return (
    <>
      {showTitle && <TitleSkeleton />}
      <div className="w-full animate-pulse delay-100">
        {Array.from({ length: rows }).map((_, idx) => (
          <div key={idx} className="flex items-center mb-1">
            <div className={`w-2/3 bg-gray-200 rounded`} style={{ height: `${rowHeight}px` }}></div>
            <div
              className={`w-1/3 bg-gray-200 rounded ml-1`}
              style={{ height: `${rowHeight}px` }}
            ></div>
          </div>
        ))}
      </div>
    </>
  );
};
